import { Pause, PlayArrow, VolumeOff, VolumeUp } from '@mui/icons-material';
import { IconButton, Slider } from '@mui/material';
import { Stack } from '@mui/system';
import React, { useEffect, useRef, useState } from 'react';

const VideoPlayer = ({ handleClose, isPlaying, setIsPlaying, isMuted, setIsMuted, videoSource }) => {
    const videoRef = useRef(null);
    const [volume, setVolume] = useState(1);
    const [showControls, setShowControls] = useState(false);


    useEffect(() => {
        if (isPlaying) {
            videoRef.current.play();
        }
    }, [isPlaying])


    const handlePlayPause = () => {
        const video = videoRef.current;

        if (video.paused) {
            video.play();
            setIsPlaying(true);
        } else {
            video.pause();
            setIsPlaying(false);
        }
    };

    const handleMuteToggle = () => {
        const video = videoRef.current;

        if (video.muted) {
            video.muted = false;
            setIsMuted(false);
        } else {
            video.muted = true;
            setIsMuted(true);
        }
    };

    const handleVolumeChange = (e) => {
        const video = videoRef.current;
        const newVolume = parseFloat(e.target.value);

        video.volume = newVolume;
        setVolume(newVolume);
    };

    const handleMouseEnter = () => {
        setShowControls(true);
    };

    const handleMouseLeave = () => {
        setShowControls(false);
    };

    return (
        <div className="video-responsive" >
            <video
                onClick={handlePlayPause}
                ref={videoRef}
                src={videoSource}
                // width="400" 
                 controls 
                onEnded={handleClose}
                style={{ position: 'absolute', transform: 'scale(1.085)' }}
            ></video>



            <Stack
                id="customControls"
                direction="row"
                justifyContent="center"
                spacing={1}
                sx={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    height: 40,
                    background: 'linear-gradient(0, #828282, transparent)',
                    backdropFilter: 'blur(5px)',
                    display: 'flex',
                    alignItems: 'center'
                }}
            >

                <IconButton
                    className="play-button"
                    aria-label="close"
                    color="inherit"
                    sx={{ p: 0.5 }}
                    onClick={handlePlayPause}
                >
                    {isPlaying ? <Pause /> : <PlayArrow />}
                </IconButton>

                <IconButton
                    className="mute-button"
                    aria-label="close"
                    color="inherit"
                    sx={{ p: 0.5 }}
                    onClick={handleMuteToggle}
                >
                    {isMuted ? <VolumeOff /> : <VolumeUp />}
                </IconButton>

                <Slider
                    min={0}
                    max={1}
                    step={0.1}
                    value={volume}
                    onChange={handleVolumeChange}
                    aria-label="Volume"
                    sx={{ width: 100 }}
                />

            </Stack>
        </div>
    );

}

export default VideoPlayer;
